module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f15f9970003001"
    }
  }), _c('p', {
    staticClass: "booktitle"
  }, [_vm._v("The Beader’s Bible")]), _c('p', {
    staticClass: "book-title-author"
  }, [_vm._v("DOROTHY WOOD")]), _c('div', {
    staticClass: "book-title-imprint"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f15fg3001.png",
      "width": "16.69691%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c180f2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch003.vue
// module id = 66
// module chunks = 0